import { type UseQueryResult, useQuery } from 'react-query';
import { IndustrySectorService } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetIndustrySectorOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const industrySectorOptions = useQuery(
    ['getIndustrySector'],
    async () => {
      return await handleRequest(
        IndustrySectorService.getApiCustomerApiAppIndustrySectorIndustrySectors()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return industrySectorOptions;
};

export default useGetIndustrySectorOptions;
